<template>
  <div class="popup">
    <transition name="popupBody">
      <div
        class="popup_body"
        @click.self="maskCloseClick"
        :style="popupBodyStyle"
        v-show="popupBodyShow"
      >
        <transition
          @before-enter="beforeEnter"
          @afterLeave="afterLeave"
          @before-leave="beforeLeave"
          name="popup"
        >
          <div class="popup_content " v-show="popupShow">
            <slot>
              <i>弹窗内容区</i>
            </slot>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    // 双向绑定 是否显示弹窗
    value: {
      type: Boolean,
      default: false
    },
    // 动画执行时长
    popupDirection: {
      type: String | Number,
      default: 0.5 //s
    },
    // 是否点击遮盖层退出弹窗
    maskClose: {
      type: Boolean,
      default: true
    },
    // 是否显示遮盖层
    mask: {
      type: Boolean,
      default: true
    },
    // 遮盖层颜色
    maskColor: {
      type: String,
      default: "rgba(0, 0, 0, 0.25)"
    }
  },
  computed: {
    popupBodyStyle() {
      // return null;
      let bgColor = this.mask ? this.maskColor : "transparent";
      return `backgroundColor:${bgColor};`;
    },
    popupBodyClass() {
      // if (this.popupShow) {
      //   return "popupBody-enter-active";
      // } else {
      //   return "popupBody-leave-active";
      // }
    }
  },

  data() {
    return {
      popupBodyShow: false,
      popupShow: false
    };
  },
  created() {
    const isSupported =
      window.CSS && window.CSS.supports && window.CSS.supports("--a", 0);
    if (isSupported) {
      // 设置变量
      document.body.style.setProperty(
        "--popupDirection",
        this.popupDirection + "s"
      );
      document.body.style.setProperty("--popupBodyBGColor", this.maskColor);
    } else {
      /* not supported */
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val == true) {
          this.showPopup();
        } else {
          this.hidenPopup();
        }
      }
      // immediate: true
    }
  },
  mounted() {
    if (this.value) {
      this.showPopup();
    }
  },
  methods: {
    // 点击遮盖层退出判断处理
    maskCloseClick() {
      if (!this.maskClose) return;
      this.hidenPopup();
    },
    // 隐藏弹窗
    hidenPopup() {
      this.popupShow = false;
      // 使用 v-show而不是v-if可以一起隐藏
      this.popupBodyShow = false;
      this.$emit("input", false);
    },
    // 显示弹窗
    showPopup() {
      this.popupBodyShow = true;
      this.popupShow = true;
    },
    beforeEnter() {
      // this.popupBodyShow = true;
    },
    beforeLeave() {
      // this.popupBodyShow = false;
    },
    // 动画执行完成  隐藏遮盖层 回调close
    afterLeave() {
      // this.popupBodyShow = false;
      this.$emit("close");
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
body {
  --popupDirection: 0.5s;
  --popupBodyBGColor: rgba(0, 0, 0, 0.25);
}
@keyframes popupBodyAnimate {
  0% {
    background-color: transparent;
  }
  100% {
    background-color: rgba(0, 0, 0, 0.25);
    background-color: var(--popupBodyBGColor);
  }
}
@keyframes popupAnimate {
  0% {
    transform: scale(0);
  }

  40% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}
.popup-enter-active {
  animation: popupAnimate ease 0.5s;
  animation: popupAnimate ease var(--popupDirection);
}

.popup-leave-active {
  animation: popupAnimate ease 0.5s reverse;
  animation: popupAnimate ease var(--popupDirection) reverse;
}
.popupBody-enter-active {
  animation: popupBodyAnimate ease 0.5s;
  animation: popupBodyAnimate ease var(--popupDirection);
}

.popupBody-leave-active {
  animation: popupBodyAnimate ease 0.5s reverse;
  animation: popupBodyAnimate ease var(--popupDirection) reverse;
}
.popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1999;
  .btn2 {
    position: absolute;
    z-index: 1;
  }
  .popup_body {
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    .popup_content {
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/defalut-popup/popup.vue